<template>
  <div class="home container">
    <div class="row">
      <div class="col-md-2 offset-md-10">
        <div class="menu-instruction-heading">
          <h5 class="graphik-light-web">
            Level select
          </h5>
        </div>
      </div>
    </div>

    <div class="row ">
      <div class="col-md-10 ">
        <div class="image-wrapper hero-wrapper">
          <img src="../assets/home/hero.jpg" alt="Hero image">
        </div>
      </div>

      <div class="col-md-2  ">
        <ul class="menu-list">
          <li v-for="(curLevel, index) in levels" :key="index"  >
            <router-link  class="btn draw-border animated fadeInUp"  :style="{ 'animation-delay': `${index*200}ms` }"  :to="{ name: 'levels', params: { level: curLevel }}">
              <span v-if="curLevel != 0">
                Level {{ curLevel }}
              </span>
              <span v-else>
                Ground
              </span>
            </router-link>
          </li>
        </ul>

      <div class="gallery-button-wrapper  animated fadeInUp" style="animation-delay:1500ms">
        <h5 class="graphik-light-web">
          Gallery
        </h5>
        <router-link  class="btn draw-border" :to="{ name: 'gallery' }">
          View
        </router-link>
      </div>

      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {

  },
  data() {
    return {
      levels: '',
      apartment: ''
    }
  },
  created() {
    this.levels = this.$store.state.levels
    this.apartment = this.$store.getters.getApartmentByNumber(2)
  },
}
</script>

<style lang="scss">
  .hero-wrapper {
    margin-bottom: 20px;
  }

</style>
